export type CookieConsentStatus = 'accepted' | 'rejected' | null;

export const COOKIE_CONSENT_KEY = 'newsforyou_cookie_consent';

export const getCookieConsent = (): CookieConsentStatus => {
  const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
  if (consent === 'accepted' || consent === 'rejected') {
    return consent as CookieConsentStatus;
  }
  return null;
};

export const setCookieConsent = (status: 'accepted' | 'rejected'): void => {
  localStorage.setItem(COOKIE_CONSENT_KEY, status);
  
  // Dispatch custom event for real-time updates
  window.dispatchEvent(new CustomEvent('cookieConsentChanged', { 
    detail: { status } 
  }));
};

export const hasAnalyticsConsent = (): boolean => {
  const consent = getCookieConsent();
  // Opt-out: ativo por padrão (null ou accepted = true)
  return consent !== 'rejected';
};

export const clearCookieConsent = (): void => {
  localStorage.removeItem(COOKIE_CONSENT_KEY);
};